import { Gql } from '@fiverr-private/dynamic_matching';

interface TransformFreelancerPreferencesArgs {
    languages?: {
        languageCode: Gql.LanguageCode;
        minProficiency: Gql.LanguageProficiencyLevel;
    }[];
    freelancerType?: {
        minLevel: Gql.DmBriefSellerLevel | null;
        isVettedPro: boolean | null;
        agencyPreference: Gql.DmBriefAgencyPreference | null;
    } | null;
    countries?: Gql.DmBriefCountryCode[] | null;
    regions?: string[] | null;
    timezone?: { [key: string]: any } | null;
}

export function transformFreelancerPreferences(prefs?: TransformFreelancerPreferencesArgs | null) {
    if (!prefs) {
        return undefined;
    }

    return {
        languages:
            prefs.languages?.map((lang) => ({
                language_code: lang.languageCode,
                min_proficiency: lang.minProficiency,
            })) || [],

        freelancer_type: prefs.freelancerType
            ? {
                  min_level: prefs.freelancerType.minLevel ?? undefined,
                  is_vetted_pro: prefs.freelancerType.isVettedPro ?? undefined,
                  agency_preference: prefs.freelancerType.agencyPreference ?? undefined,
              }
            : undefined,

        countries: prefs.countries || [],
        regions: prefs.regions || [],
    };
}
